module.exports = "/images/avatar-default.svg?b51e4fd0cc3070bba4cee88913f5c32f";